var map = {
	"./bg_valentine.jpg": "39c9",
	"./jeze.jpg": "8ae4",
	"./jeze.jpg.mini.jpg": "d098",
	"./wiewioreczki-small.jpg": "78fc",
	"./wiewiory.jpg": "5380",
	"./wiewiory.jpg.mini.jpg": "2e54",
	"./zuki.jpg": "943d",
	"./zuki.jpg.mini.jpg": "c42a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bacc";